import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { observer, inject } from 'mobx-react'
import * as helpers from '../lib/HelperFunctions'
// import Logger from '../stores/Logger'
import { AutoSizer } from 'react-virtualized'
import { VirtualKanban } from 'react-virtual-kanban'
import Logger from '../stores/Logger'
import { listFilterModes } from '../stores/IdeaStore'
// Import only once
import 'react-virtual-kanban/lib/styles.css'
import moment from 'moment'
import firebase from '../firebase'
import DashboardIdeaItem from '../components/DashboardIdeaItem'
import DashboardIdeaItemPreview from '../components/DashboardIdeaItemPreview'
import DashboardIdeaList from '../components/DashboardIdeaList'
import './css/Dashboard.css'
import { listModes } from '../containers/IdeaList'
import { majorModes } from './Header'
import { dueDateModes } from '../stores/IdeaStore'

const keyGenerator = ({ id, lastModified }) => `${id}-${lastModified}-${new Date().getTime()}`

class Dashboard extends Component {
    constructor(props) {
        super(props)
        this.returnWidth = this.returnWidth.bind(this)
        this.returnHeight = this.returnHeight.bind(this)
        this.handleSearchClick = this.handleSearchClick.bind(this)

        this.state = {
            data: [],
            filteredList: [],
            filterMode: '',
            searchBarText: '',
            movedColumnValue: '',
            loadedTeamStages: [],
            loadedTeamTags: [],
            loadedTeamMembers: [],
            loadedTeamUsers: [],
        }

    }
    componentWillMount(){
        const { stores } = this.props
        const { authStore, prefStore, toolStore } = stores
        let noTeamStages = toolStore.defaultStages.toJSON()
        let noTeamTags = []
        const authUser = authStore.authUser()
        prefStore.findTeam(authUser.uid).then(() => {
            if(prefStore.defaultIdeaTags.length > 0){
                this.setState({
                    loadedTeamTags: prefStore.defaultIdeaTags,
                })
            } else {
                firebase.database().ref().child('tags').once('value',tagsSnap => {
                    if(tagsSnap.exists()){
                        noTeamTags = tagsSnap.val()
                        this.setState({
                            loadedTeamTags: noTeamTags,
                        })
                    }
                })
            }

            ///////////////////////

            if (prefStore.defaultIdeaStages.length > 0){
                this.setState({
                    loadedTeamStages: prefStore.defaultIdeaStages.toJSON(),
                })
            } else {
                firebase.database().ref().child('stages').once('value',stagesSnap => {
                    if(stagesSnap.exists()){
                        noTeamStages = stagesSnap.val()
                        this.setState({
                            loadedTeamStages: noTeamStages,
                        })
                        this.prepareData()
                    }
                })
            }

            //////////////////////////

            if (Object.keys(prefStore.teamMembers).length > 0){
                // console.log('team users', prefStore.teamUsers)
                this.setState({
                    loadedTeamMembers: Object.keys(prefStore.teamMembers),
                    loadedTeamUsers: prefStore.teamUsers,
                })
                this.prepareData()
            } else {
                this.prepareData()
            }
        })
    }
    componentDidMount() {
        const { stores } = this.props
        const { authStore, prefStore } = stores
        this.setState({ filteredList: this.props.filteredIdeasToShow }, () => {
            let team = authStore.auth.primaryTeam
            if (prefStore.dashOrder === 'Idea owners' && !team.hasOwnProperty('members')) {
                setTimeout(() => {
                    this.prepareData() //Little hack: loads data after the team loads,
                    //otherwise the list doesn't find a team in time (timing issue)
                    //this occurs only while the team didn't load (which is once)
                }, 500)
            }
            else {
                this.prepareData()
            }
        })
    }
    componentWillReceiveProps(nextProps) {
        const { stores } = this.props
        const { authStore } = stores
        if (this.state.filteredList) {
            if (this.state.filteredList !== nextProps.filteredIdeasToShow) {
                authStore.loadTeam()
                this.setState({ filteredList: nextProps.filteredIdeasToShow }, () => {
                    this.prepareData()
                })
            }
        }
    }
    onMoveRow(args) {
        // console.log('onMoveRow',JSON.stringify(args))
        //Logger.trackEvent('onMoveRow','args',JSON.stringify(args))
    }
    onDragEndRow(args) {
        this.onDropRow(args)
    }
    onDropRow(args) {
        // console.log('onDropRow',JSON.stringify(args))
        // console.log('setting stage=',args.listIndex,'for idea',args.itemId)
        const { stores } = this.props
        const { store, prefStore } = stores
        if (prefStore.dashOrder === 'Stage') {
            this.setState({movedColumnValue: args.listIndex})
            store.updateIdeaProp(
                args.rowId,
                'currentStage',
                args.listIndex,
            )
        } else if (prefStore.dashOrder === 'Recommendation') {
            this.setState({movedColumnValue: args.listIndex})
            let comps = helpers.reverseRatingCalc(args.listIndex)
            Object.keys(comps).forEach((comp) => {
                store.updateIdeaProp(
                    args.rowId,
                    comp,
                    comps[comp],
                )
            })
        }
        if (prefStore.dashOrder !== 'Stage' && prefStore.dashOrder !== 'Recommendation') {
            const { stores } = this.props
            const { store, prefStore } = stores
            Logger.trackEvent('onDropRowNotAllowed', 'mode', prefStore.dashOrder)
            this.forceUpdate()
            store.infoAlert = 'Not possible to move ideas in ' + prefStore.dashOrder + ' mode.'
            window.setTimeout(() => {
                store.infoAlert = undefined
            }, 3000)
        }
    }
    prepareData(filteredList) {
        const { prefStore } = this.props.stores
        const {
            dashPref,
            dashOrder,
        } = prefStore
        
        const value = dashPref
        Logger.trackEvent('prepareData', 'dashOrder', dashOrder)
        switch (dashOrder) {
            case 'Stage':
                this.setState({ data: this.ideasByStage(value, dashOrder, filteredList) })
                break
            case 'Recommendation':
                this.setState({ data: this.ideasByRecommendation(value, dashOrder, filteredList) })
                break
            case 'Age':
                this.setState({ data: this.ideasByTimestamp('timestamp', value, dashOrder, filteredList) })
                break
            case 'Last Updated':
                this.setState({ data: this.ideasByTimestamp('lastUpdated', value, dashOrder, filteredList) })
                break
            case 'Due date':
                this.setState({ data: this.ideasByDueDate('dueDate', value, dashOrder, filteredList) })
                break
            case 'Team Size':
                this.setState({ data: this.ideasByTeamSize(value, dashOrder, filteredList) })
                break
            case 'Tags':
                this.setState({ data: this.ideasByTags(value, dashOrder, filteredList) })
                break
            case 'Idea owners':
                this.setState({ data: this.ideasByUsers(value, dashOrder, filteredList) })
                break
            default:
                console.error('Invalid mode:', dashOrder)
                break
        }
    }
    returnWidth(width) {
        if (width !== 0 && width < 500) {
            this.props.stores.prefStore.viewMode = listModes.compact
            this.props.stores.prefStore.majorMode = majorModes.ideas
            this.props.stores.prefStore.storeUserPreferences()
            this.props.stores.prefStore.openSidebar = false
            return 280
        }
        else {
            width = width / this.state.data.length
            if (width < 280) {
                return 280
            }
            else {
                return width
            }
        }
    }
    returnHeight(height) {
        if (height < 350) {
            return 0
        }
        else {
            return height
        }
    }
    transformData(ideasByX, dashPref, mode) {
        const { stores } = this.props
        const { toolStore } = stores
        let data = []
        let color = 'white'
        let boxShadow = '1px 1px 0px 0px #ccc'
        if (Object.keys(ideasByX).length > 0) {
            Object.keys(ideasByX).forEach(element => {
                let ideasInX = ideasByX[element]
                let rows = []
                let border = '1px solid #dfdfdf'
                ideasInX.forEach(idea => {
                    var date = new Date(idea.timestamp)
                    var dueDate = null
                    date = date.getDate() + '.' + (date.getMonth() + 1) + '.' + date.getFullYear()
                    if (idea.dueDate && idea.dueDate !== '') {
                        dueDate = new Date(idea.dueDate)
                        dueDate = dueDate.getDate() + '.' + (dueDate.getMonth() + 1) + '.' + dueDate.getFullYear()
                    }
                    rows.push({
                        id: idea.key,
                        name: idea.name,
                        color: color,
                        border: border,
                        mode: mode,
                        boxShadow: boxShadow,
                        currentStage: toolStore.stages[idea.currentStage],
                        lastUpdated: moment(idea.lastUpdated).fromNow(),
                        timestamp: date,
                        dueDate: dueDate,
                        ownerPhotoURL: idea.ownerPhotoURL,
                        ownerName: idea.ownerName,
                        responsible: idea.responsible,
                        showOwner: dashPref.indexOf('owner') > -1,
                        showCreationDate: dashPref.indexOf('creationDate') > -1,
                        showLastUpdated: dashPref.indexOf('lastUpdated') > -1,
                        showDueDate: dashPref.indexOf('dueDate') > -1,
                        showStage: dashPref.indexOf('stage') > -1,
                        impactRating: idea.impactRating,
                        effortRating: idea.effortRating,
                        showRec: dashPref.indexOf('rec') > -1,
                        tags: idea.tags,
                        showTags: dashPref.indexOf('tags') > -1,
                        imageUrl: idea.imageUrl,
                        showImage: dashPref.indexOf('image') > -1,
                        teamSize: idea.hasOwnProperty('team') ? idea.team.length + 1 : 1,
                        showTeamSize: dashPref.indexOf('teamSize') > -1,
                    })
                })
                let col = { id: element, rows: rows }
                data.push(col)
            })
        }
        return data
    }
    ideasByStage(dashPref, mode) {
        let res = {}
        if (this.props.filteredIdeasToShow) {
            this.state.loadedTeamStages.forEach((stage, index) => {
                let stageFilter = new RegExp(index, 'i')
                let arr = this.props.filteredIdeasToShow.filter(idea => (stageFilter.test(idea.currentStage)))
                res[stage] = arr
            }) 
        }
        return this.transformData(res, dashPref, mode)
    }
    ideasByUsers(dashPref, mode) {
        const { stores } = this.props
        const { authStore } = stores
        //authStore.loadTeam()
        let team = authStore.auth.primaryTeam
        let ownerArray = []
        // console.log('this.state.loadedTeamMembers', this.state.loadedTeamMembers)
        // console.log('loaded team users ', this.state.loadedTeamUsers)
        if(this.state.loadedTeamUsers.length > 0){
            if (team.hasOwnProperty('members')) {
                Object.keys(team.members).forEach((member, memberIndex) => {
                    ownerArray.push({ ownerName: this.state.loadedTeamUsers[memberIndex].displayName, ownerEmail: this.state.loadedTeamUsers[memberIndex].email })
                })
            }
        }
        let res = {}
        if (this.props.filteredIdeasToShow) {
            if (ownerArray.length > 0) {
                ownerArray.forEach((owner, index) => {
                    let arr = this.props.filteredIdeasToShow.filter(idea => {
                        if (idea.hasOwnProperty('responsible')) {
                            return (idea.responsible.email === owner.ownerEmail)
                        }
                        else return (idea.owner === owner.ownerEmail)
                    })
                    res[owner.ownerName] = arr
                })
            }
        }
        return this.transformData(res, dashPref, mode)
    }
    ideasByRecommendation(dashPref, mode) {
        let res = {}

        const recs = ['Unrated', 'Avoid', 'Maybe', 'Project', 'Do']
        if (this.props.filteredIdeasToShow) {
            recs.forEach((rec, index) => {
                let recFilter = new RegExp(index, 'i')
                let arr = this.props.filteredIdeasToShow.filter(idea => (recFilter.test(helpers.calcRatingNum(idea.effortRating, idea.impactRating))))
                res[rec] = arr
            })
        }
        return this.transformData(res, dashPref, mode)
    }
    ideasByDueDate(prop = 'timestamp', dashPref, mode) {
        let res = []
        let ageLimits = []
        const ageLimitsDefault = [
            new Date(), //now
            new Date().setDate(new Date().getDate() + 7), //in the next 7 days
            new Date().setDate(new Date().getDate() + 7), //in the next 7 days
            new Date().setDate(new Date().getDate() + 14), //in the next 14 days
            new Date().setMonth(new Date().getMonth() + 1), //in the next month
            new Date().setMonth(new Date().getMonth() + 2), //in the next 2 months
        ]

        const ageLimitsWeeks = [
            new Date() - 1, //now [0]
            new Date().setDate(new Date().getDate() + 7), //in the next week [1]
            new Date().setDate(new Date().getDate() + 7), //in the next week [2]
            new Date().setDate(new Date().getDate() + 14), //in the next 2 weeks [3]
            new Date().setDate(new Date().getDate() + 21), //in the next 3 weeks [4]
            new Date().setDate(new Date().getMonth() + 1), // in the next month [5]
        ]
        const ageLimitsMonths = [
            new Date() - 1, // now [0]
            new Date().setMonth(new Date().getMonth() + 1), //in the next month [1]
            new Date().setMonth(new Date().getMonth() + 1), //in the next month [2]
            new Date().setMonth(new Date().getMonth() + 2), //in the next 2 months [3]
            new Date().setMonth(new Date().getMonth() + 3), //in the next 3 months [4]
            new Date().setMonth(new Date().getMonth() + 4), //in the next 4 months [5]
        ]
        const ageLimitsYears = [
            new Date() - 1, // now [0]
            new Date().setFullYear(new Date().getFullYear() + 1), //in the next years [1]
            new Date().setFullYear(new Date().getFullYear() + 1), //in the next years [2]
            new Date().setFullYear(new Date().getFullYear() + 2), //in the next 2 years [3]
            new Date().setFullYear(new Date().getFullYear() + 3), //in the next 3 years [4]
            new Date().setFullYear(new Date().getFullYear() + 4), //in the next 4 years [5]
        ]

        let dueDateMode = this.props.stores.prefStore.dueDateMode
        let columnNames = []
        if (dueDateModes) {
            switch (dueDateMode) {
                case dueDateModes.byWeek:
                    columnNames = ['Within a week', 'Within 2 weeks', 'Within 3 weeks']
                    ageLimits = ageLimitsWeeks
                    break
                case dueDateModes.byMonth:
                    columnNames = ['Within a month', 'Within 2 months', 'Within 3 months']
                    ageLimits = ageLimitsMonths
                    break
                case dueDateModes.byYear:
                    columnNames = ['Within a year', 'Within 2 years', 'Within 3 years']
                    ageLimits = ageLimitsYears
                    break
                default:
                    columnNames = ['Due next week', 'Due in 2 weeks', 'Due in next month']
                    ageLimits = ageLimitsDefault
                    break
            }
        }

        if (this.props.filteredIdeasToShow) {
            ageLimits.forEach((ageLimit, index) => {
                if (index < ageLimits.length - 1) { //skip the last one
                    let arr = this.props.filteredIdeasToShow.filter(idea => {
                        let ts = new Date(idea[prop])
                        if (index === 0) {
                            return (ts <= new Date().setDate(new Date().getDate() - 1))
                        }
                        if (index === 1) {
                            return (ts <= ageLimits[1] && ts >= new Date().setDate(new Date().getDate() - 1))
                        }
                        if (index === 4) {
                            return (ts >= ageLimits[4])
                        }
                        else {
                            return (ts >= ageLimit && ts <= ageLimits[index + 1])
                        }
                    })
                    if (index === 0)
                        res['Past due'] = arr
                    else if (index === ageLimits.length - 2)
                        res['Due later'] = arr
                    else
                        res[columnNames[index - 1]] = arr
                }
            })
        }
        return this.transformData(res, dashPref, mode)
    }
    ideasByTimestamp(prop = 'timestamp', dashPref, mode) {
        let res = {}

        const ageLimits = [
            new Date().setMonth(new Date().getMonth() - 3), // 3 months ago
            new Date().setMonth(new Date().getMonth() - 2), // 2 months ago
            new Date().setMonth(new Date().getMonth() - 1), // 1 month ago
            new Date().setDate(new Date().getDate() - 14), // 14 days ago
            new Date().setDate(new Date().getDate() - 7), // 7 days ago
            new Date(), //now
        ]
        if (this.props.filteredIdeasToShow) {
            ageLimits.forEach((ageLimit, index) => {
                if (index < ageLimits.length - 1) { //skip the last one
                    let arr = this.props.filteredIdeasToShow.filter(idea => {
                        let ts = new Date(idea[prop])
                        if (index === 0)
                            return (ts <= ageLimits[0])
                        else
                            return (ts >= ageLimit && ts <= ageLimits[index + 1])
                    })
                    if (index === 0)
                        res['more than ' + moment(ageLimits[index + 1]).fromNow()] = arr
                    else if (index === ageLimits.length - 2)
                        res['less than ' + moment(ageLimit).fromNow()] = arr
                    else
                        res[moment(ageLimit).fromNow() + '-' + moment(ageLimits[index + 1]).fromNow()] = arr
                }
            })
        }
        return this.transformData(res, dashPref, mode)
    }
    ideasByTeamSize(dashPref, mode) {
        let res = {}
        const sections = [
            { name: 'only owner', teamSize: 0 },
            { name: '1 invited', teamSize: 1 },
            { name: '2 invited', teamSize: 2 },
            { name: '3 invited', teamSize: 3 },
            { name: '4 or more invited', teamSize: 4 },
        ]
        if (this.props.filteredIdeasToShow) {
            sections.forEach((section, index) => {
                let arr = this.props.filteredIdeasToShow.filter(idea => {
                    if (!idea.hasOwnProperty('team'))
                        return (section.teamSize === 0)
                    else {
                        if (sections.length - 1 === index)
                            return (idea.team.length >= section.teamSize)
                        else
                            return (section.teamSize === idea.team.length)
                    }
                })
                res[section.name] = arr
            })
        }
        return this.transformData(res, dashPref, mode)
    }
    ideasByTags(dashPref, mode) {
        let res = {}
        if (this.props.filteredIdeasToShow) {
            this.state.loadedTeamTags.forEach((section, index) => {
                let filter = new RegExp(section, 'i')
                let arr = this.props.filteredIdeasToShow.filter(idea => (filter.test(idea.tags)))
                res[section] = arr
            })
        }
        return this.transformData(res, dashPref, mode)
    }
    returnFilterTag() {
        if (this.props.stores.prefStore.listFilterMode === listFilterModes.workOn) {
            return 'I work on'
        }
        else if (this.props.stores.prefStore.listFilterMode === listFilterModes.responsibleFor) {
            return 'I am responsible for'
        }
    }
    deleteFilterTag() {
        this.props.stores.prefStore.listFilterMode = 0
        this.props.stores.prefStore.storeUserPreferences()
        Logger.trackEvent('deleteFilterTag')
    }
    changeFilter(e) {
        const { stores } = this.props
        const { store } = stores
        store.handleFilterChange(e)
    }
    changeSort(e) {
        const { stores } = this.props
        const { store } = stores
        store.handleSortChange(e)
    }
    changeSearchBarText(e) {
        this.setState({ searchBarText: e.target.value })
    }
    handleSearchClick() {
        this.props.stores.prefStore.listSearchText = this.state.searchBarText
        this.props.stores.prefStore.storeUserPreferences()
        Logger.trackEvent('filterIdeas', 'filterString', this.state.searchBarText)
    }
    filter(e) {
        if (e.key === 'Enter') {
            this.props.stores.prefStore.listSearchText = this.state.searchBarText
            this.props.stores.prefStore.storeUserPreferences()
            Logger.trackEvent('filterIdeas', 'filterString', this.state.searchBarText)
        }
    }
    render() {
        return (
            <div className='dashCardContainer'>
                {this.state.data.length > 0 &&
                    <AutoSizer>
                        {({ width, height }) => (
                            <VirtualKanban
                                lists={this.state.data}
                                width={width}
                                height={this.returnHeight(height)}
                                listWidth={this.returnWidth(width)}
                                itemCacheKey={keyGenerator}
                                // dndDisabled={!canDrag}
                                itemComponent={DashboardIdeaItem}
                                itemPreviewComponent={DashboardIdeaItemPreview}
                                listComponent={DashboardIdeaList}
                                overscanListCount={5}
                                onMoveRow={this.onMoveRow.bind(this)}
                                onDropRow={this.onDropRow.bind(this)}
                                onDragEndRow={this.onDragEndRow.bind(this)}>
                            </VirtualKanban>
                        )}
                    </AutoSizer>
                }
            </div>
        )
    }
}
Dashboard.propTypes = {
    filteredIdeasToShow: PropTypes.array.isRequired,
/*     showFields: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired, */
}

export default inject("stores")(observer(Dashboard))



// WEBPACK FOOTER //
// ./src/containers/Dashboard.js